import { RootState } from "../store";
import { IWagonEventCreateState, Status } from "../types/state";
import { IWagonEventCreate } from "../types/wagonEvent";

export const getWagonEventCreateState = (state: RootState): IWagonEventCreateState => state.wagonEventCreate;
export const getWagonEventCreate = (state: RootState): IWagonEventCreate => state.wagonEventCreate.wagonEvent;
export const getWagonEventCreateStatus = (state: RootState): Status => state.wagonEventCreate.status;
